import { render, staticRenderFns } from "./GiftIdeasMenu.vue?vue&type=template&id=d66750bc&scoped=true&"
import script from "./GiftIdeasMenu.vue?vue&type=script&lang=js&"
export * from "./GiftIdeasMenu.vue?vue&type=script&lang=js&"
import style0 from "./GiftIdeasMenu.vue?vue&type=style&index=0&id=d66750bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66750bc",
  null
  
)

export default component.exports